// src/utils/invitationCodeGenerator.ts

/**
 * Generates a specified number of unique invitation codes
 * @param count Number of unique codes to generate
 * @param length Length of each code (default: 8)
 * @returns Array of unique invitation codes
 */
export const generateInvitationCodes = (count: number, length: number = 8): string[] => {
    if (count <= 0) return [];
    
    const codes = new Set<string>();
    
    // Characters to use for code generation (alphanumeric without ambiguous characters)
    const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    
    while (codes.size < count) {
      let code = '';
      
      // Generate a random code
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        code += characters.charAt(randomIndex);
      }
      
      // Add code if not already in the set
      codes.add(code);
    }
    
    return Array.from(codes);
  };
  
  /**
   * Validates an invitation code format
   * @param code The code to validate
   * @returns Boolean indicating if the code format is valid
   */
  export const validateInvitationCode = (code: string): boolean => {
    // Alphanumeric only, minimum length 6, maximum length 12
    const codeRegex = /^[A-Z0-9]{6,12}$/;
    return codeRegex.test(code);
  };